<template>
  <b-modal ref="masksSelector"
           :title="$t('evaluation.masks')"
           :ok-title="$t('open')"
           :cancel-title="$t('cancel')"
           size="lg"
           centered
           @ok.prevent="">
    <div>
      <!-- Display -->
      <div class="form-group row">
        <label for="toshow" class="col-md-3 col-form-label text-md-right">{{ $t('display') }}</label>
        <div class="col-md-7">
          <select id="toshow" v-model="category" class="custom-select" name="toshow">
            <option v-for="(cat, i) in categories" :value="i">{{ $t('evaluation.mask.categories.' + cat) }}</option>
          </select>
        </div>
      </div>
      <!-- Search -->
      <div class="form-group row">
        <label for="search" class="col-md-3 col-form-label text-md-right">{{ $t('search') }}</label>
        <div class="input-group col-md-7">
          <div class="input-group-prepend">
            <span class="input-group-text"><fa icon="search" /></span>
          </div>
          <input id="search" :placeholder="$t('search')" v-model="search" type="text" class="form-control" name="search" >
        </div>
      </div>
      <!-- Table -->
      <div class="w-100">
        <table class="table">
          <thead>
            <tr>
              <th>{{ $t('title') }}</th><th>{{ $t('author') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="mask in displayedMasks"
                :class="{ 'bg-light': selected.id == mask.id }"
                @click="selected = mask">
              <td>{{ mask.title }}</td>
              <td>{{ `${mask.creator.first_name} ${mask.creator.last_name}` }}</td>
            </tr>
          </tbody>
        </table>
        <PaginationBlock v-if="searchFiltered" :page-count-steps="pageCountSteps" :length="searchFiltered.length" v-model="page" />

      </div>
    </div>
    <div slot="modal-footer" class="w-100">
      <div class="float-right">
        <b-btn variant="secondary" @click="$refs.masksSelector.hide()">{{ $t('cancel') }}</b-btn>
        <b-btn variant="primary" @click="openMask">{{ $t('open') }}</b-btn>
      </div>
    </div>
  </b-modal>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'

export default {
  name: 'MasksSelector',

  props: {
    masks: { type: Array, required: true }
  },

  data: () => ({
    categories: ['all', 'owned', 'approved'],
    category: 0,
    search: '',
    selected: -1,
    page: { page: 1, count: 10 },
    pageCountSteps: [10, 25, 50, 100]

  }),

  computed: {
    ownedMasks: function () {
      return this.masks.filter(x => x.creator_id == this.user.id)
    },

    approvedMasks: function () {
      return this.masks.filter(x => x.approved)
    },

    toShow: function () {
      switch (this.category) {
        case 1: return this.ownedMasks
        case 2: return this.approvedMasks
        default: return this.masks
      }
    },

    searchFiltered: function () {
      if (this.search.length > 1) {
        let searchTerm = this.search.toLowerCase()
        return this.toShow.filter(x => x.title.toLowerCase().includes(searchTerm))
      }

      return this.toShow
    },

    displayedMasks () {
      if (this.searchFiltered) {
        const start = (this.page.page - 1) * this.page.count
        const end = start + this.page.count
        return this.searchFiltered.slice(start, end)
      }
      return this.searchFiltered
    },
    ...mapGetters({
      user: 'auth/user'
    })
  },

  methods: {
    hide () {
      this.$refs.masksSelector.hide()
    },

    show () {
      this.$refs.masksSelector.show()
    },

    openMask () {
      if (this.selected) { this.$emit('openMask', this.selected) }
      this.hide()
    }
  }
}
</script>



// WEBPACK FOOTER //
// ../../../../resources/js/components/MasksSelector.vue